import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
import Tooltip from 'flarum/common/components/Tooltip';
import extractText from 'flarum/common/utils/extractText';

// BasicEditorDriver (the plain textarea) also exposes the element itself.

// TextEditor is untyped JS in core; this is the part used here.

/**
 * An "Insert table" button in flarum/markdown's composer toolbar, for the
 * pipe tables enabled in extend.php. It drops a three-column skeleton at the
 * cursor, on its own lines, and selects the first header to type over.
 *
 * flarum/markdown builds that toolbar in TextEditor#markdownToolbarItems,
 * which it adds by override; flarum/markdown is an optional dependency so
 * that override is in place before this extends it.
 */
export default function tableButton() {
  extend('flarum/common/components/TextEditor', 'markdownToolbarItems', function (items) {
    if (!items) return;
    items.add('bdTable', m(Tooltip, {
      text: extractText(app.translator.trans('bimmerdock-theme.forum.composer.table_tooltip'))
    }, m("button", {
      className: "Button Button--icon Button--link",
      type: "button",
      onclick: () => insertTable(this.attrs.composer.editor)
    }, m(Icon, {
      name: "fas fa-table"
    }))), -10 // last, after flarum/markdown's lists (0)
    );
  });
}
function insertTable(editor) {
  if (!editor) return;
  const column = number => extractText(app.translator.trans('bimmerdock-theme.forum.composer.table_column', {
    number
  }));
  const headers = [1, 2, 3].map(column);
  const table = [`| ${headers.join(' | ')} |`, '| --- | --- | --- |', '|  |  |  |', '|  |  |  |'].join('\n');
  const [start, end] = editor.getSelectionRange();
  const textarea = editor.el;
  const value = textarea?.value ?? '';
  const before = value.slice(0, start);
  const after = value.slice(end);

  // A table only parses as one on lines of its own, after a blank line.
  const lead = before === '' || before.endsWith('\n\n') ? '' : before.endsWith('\n') ? '\n' : '\n\n';
  const trail = after === '' || after.startsWith('\n\n') ? '' : after.startsWith('\n') ? '\n' : '\n\n';
  editor.insertBetween(start, end, lead + table + trail, false);
  if (textarea) {
    const first = start + lead.length + 2;
    textarea.setSelectionRange(first, first + headers[0].length);
    textarea.focus();
  }
}